import { useContext } from 'react'

import { PORequestsContext } from '../contexts'

export const usePORequests = () => useContext(PORequestsContext)
